import { FC, ReactNode } from "react";

export const SectionTitle: FC<{
  icon: ReactNode;
  title: string;
  count: number;
}> = ({ icon, title, count }) => (
  <span className="flex w-full items-center gap-2 text-sm">
    {icon}
    <span>{title}</span>
    <span className="text-black-tint-55">({count})</span>
  </span>
);
